import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'eoc.escalation-policies.change-state-modal.title.no-translate',
		defaultMessage: `{isEnabled, select,
      true {Turn off}
      other {Turn on}
    } escalation policy?`,
		description: 'The text will be displayed in the change state modal title.',
	},
	description: {
		id: 'eoc.escalation-policies.change-state-modal.description.no-translate',
		defaultMessage: `This will {isEnabled, select,
        true {turn off}
        other {turn on}
      } the escalation policy "{name}". You can turn it {isEnabled, select,
        true {on}
        other {off}
      } again or edit it at any time`,
		description: 'The text will be displayed in the change state modal description.',
	},
	cancelButton: {
		id: 'eoc.escalation-policies.change-state-modal.cancel-button.no-translate',
		defaultMessage: 'Cancel',
		description: 'The text will be displayed in the change state modal footer for cancel button.',
	},
	confirmButton: {
		id: 'eoc.escalation-policies.change-state-modal.delete-button.no-translate',
		defaultMessage: `{isEnabled, select,
      true {Turn off}
      other {Turn on}
    }`,
		description: 'The text will be displayed in the change state modal footer for delete button.',
	},
});
